import { productList } from './products';

export const mockData = {
  company: {
    name: 'Mahadeva Systems',
    brand: 'Sha',
    tagline: 'Smart Living, Simplified',
    email: 'info@thesha.co.in',
    phone: '+91 8500 570 590',
    description: 'Leading provider of smart home automation solutions for modern homes and offices',
    address: {
      building: '',
      street: '',
      area: '',
      city: 'Vijayawada',
      state: 'Andhra Pradesh',
      zip: '',
      country: 'India'
    },
    social_media: {
      facebook: 'https://www.facebook.com/profile.php?id=61577791305589',
      instagram: 'https://www.instagram.com/_the_sha_25_/',
      linkedin: 'https://www.linkedin.com/company/mahadeva-systems',
      youtube: 'https://www.youtube.com/@theSha-ms',
      twitter: 'https://x.com/MahadevaSystems',
      whatsapp: 'https://wa.me/+918500570590'
    },
    stats: {
      project_completed: '10+',
      states_covered: '2',
      client_satisfaction: '98%',
    }
  },

  slides: [
    {
      id: 1,
      title: 'SMART TOUCH PANELS',
      subtitle: 'Control Everything at Your Fingertips',
      description: 'Experience convenience and energy savings with intelligent automation',
      benefits: ['Save up to 30% on energy bills', 'Control from anywhere', 'Voice activated'],
      image: 'https://article.images.consumerreports.org/image/upload/t_article_tout/v1729260374/prod/content/dam/CRO-Images-2024/Home/CR-Home-Best-Home-Security-Companies-1024',
      cta: 'Get Started',
      page: 'scenarios'
    },
    {
      id: 2,
      title: 'INTELLIGENT LIGHTING',
      subtitle: 'Transform Your Space with Smart Light',
      description: 'Automated lighting that adapts to your lifestyle and saves energy',
      benefits: ['Mood-based scenes', 'Automated schedules', '80% longer bulb life'],
      image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=1920&q=80',
      cta: 'Learn More',
      page: 'solutions'
    },
    {
      id: 3,
      title: 'ADVANCED SECURITY',
      subtitle: 'Your Safety, Our Priority',
      description: '24/7 monitoring with AI-powered detection and instant alerts',
      benefits: ['Crystal clear footage', 'Smart motion detection', 'Remote monitoring'],
      image: 'https://www.gensecurity.com/hs-fs/hubfs/Blog/Home-Security--How-to-Install-Outdoor-Security-Cameras.jpg?width=1000&name=Home-Security--How-to-Install-Outdoor-Security-Cameras.jpg',
      cta: 'Request Demo',
      page: '/contact'
    }
  ],

  solutions: [
    {
      id: 1,
      title: 'Touch Panel Controls',
      description: 'Modern touch panels for seamless control of your entire home automation system',
      icon: 'touchscreen',
      category: 'Control Panels'
    },
    {
      id: 2,
      title: 'Lighting Control',
      description: 'Intelligent lighting systems that adapt to your lifestyle and save energy',
      icon: 'lightbulb',
      category: 'Control Modules'
    },
    {
      id: 3,
      title: 'Climate Control',
      description: 'Smart fan and AC control for optimal comfort and energy efficiency',
      icon: 'wind',
      category: 'Remote Control'
    },
    {
      id: 4,
      title: 'Motor Control',
      description: 'Automated control for gates, curtains, and other motor-driven systems',
      icon: 'settings',
      category: 'Control Modules'
    },
    {
      id: 5,
      title: 'CCTV Systems',
      description: 'Advanced surveillance cameras with remote monitoring capabilities',
      icon: 'video',
      category: 'Security Systems'
    },
    {
      id: 6,
      title: 'Sensor Integration',
      description: 'Motion, temperature, and security sensors for complete home automation',
      icon: 'activity',
      category: 'Security Systems'
    }
  ],

  products: productList,

  testimonials: [
    {
      id: 1,
      name: 'Rajesh Kumar',
      role: 'Homeowner',
      content: 'Mahadeva Systems transformed our home. The automation is seamless and the service is excellent!',
      rating: 5
    },
    {
      id: 2,
      name: 'Priya Sharma',
      role: 'Office Manager',
      content: 'Professional installation and great support. Our office is now completely automated.',
      rating: 5
    },
    {
      id: 3,
      name: 'Amit Patel',
      role: 'Villa Owner',
      content: 'The touch panels and lighting control exceeded our expectations. Highly recommended!',
      rating: 5
    }
  ],
};
